module.exports = __webpack_public_path__ + "static/img/healthcare.6fbc05d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/healthcare.jpeg
// module id = 21NJ
// module chunks = 7